// Taken from https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export function numberWithCommas (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function calculateConcreteWeight (squareFeet, depthInInches) {
  const pounds = Math.round((squareFeet * depthInInches) * 6.3)
  const tons = Math.round((pounds / 2000) * 1e1) / 1e1
  return { pounds, tons }
}

export function calculateShinglesWeight (type, calculationUnitName, calculationUnitValue, layers) {
  const squareWeightMap = {
    'Three-Tab Asphalt': 240,
    'Architectural Asphalt': 420,
    Slate: 950
  }

  const bundleWeightMap = {
    'Three-Tab Asphalt': 84,
    'Architectural Asphalt': 75,
    Slate: 319
  }

  let calculatedWeightPounds = 0
  if (calculationUnitName === 'squares') {
    calculatedWeightPounds = calculationUnitValue * squareWeightMap[type]
  } else {
    calculatedWeightPounds = calculationUnitValue * bundleWeightMap[type]
  }

  const calculatedWeightTons = calculatedWeightPounds / 2000

  const totalWeightPounds = (calculatedWeightPounds * layers)
  const totalWeightTons = (calculatedWeightTons * layers).toFixed(1)

  return { totalWeightPounds, totalWeightTons }
}

export function calculateCarpetWeight (squareFeet) {
  const squareYards = squareFeet / 9
  const pounds = (squareYards * 15).toFixed(2)
  const tons = (pounds / 2000).toFixed(2)
  return { pounds, tons }
}

export function calculateDrywallWeight (type, length, width, count) {
  const typeDensityMap = { // maps type to pounds per square foot
    '1/4-standard': 1.2,
    '3/8-standard': 1.4,
    '1/2-standard': 1.6,
    '5/8-standard': 2.2,
    '1/2-lightweight': 1.2,
    '5/8-lightweight': 1.65
  }

  const squareFeet = length * width
  const pounds = (squareFeet * typeDensityMap[type] * count).toFixed(1)
  const tons = (pounds / 2000).toFixed(2)
  return { pounds, tons }
}

export function calculateLumberWeight (type, dimensions, length) {
  const typeDensityMap = { // maps type to pounds per board foot
    green: 2.7,
    kilndried: 2,
    pressuretreated: 3.4
  }

  const [width, height] = dimensions.split(' x ').map(Number)
  const boardFootage = (width * height * 12 * length) / 144 // 1 board foot = 144 cubic inches
  const pounds = (boardFootage * typeDensityMap[type]).toFixed(1)
  const tons = (pounds / 2000).toFixed(2)
  return { pounds, tons }
}

export function getRecommendedDumpsterTitleBySquares (type, squares, layers) {
  const cumulativeSquares = squares * layers
  switch (type) {
    case 'Slate':
      if (cumulativeSquares <= 20) return '10 Yard Dumpster'
      return 'Multiple 10 Yard Dumpsters'
    default:
      if (cumulativeSquares <= 25) return '10 Yard Dumpster'
      if (cumulativeSquares > 25 && cumulativeSquares <= 35) return '15 Yard Dumpster'
      if (cumulativeSquares > 35 && cumulativeSquares <= 50) return '20 Yard Dumpster'
      return 'Multiple 20 yard Dumpsters'
  }
}

export function getRecommendedDumpsterTitleByBundles (type, bundles, layers) {
  const cumulativeBundles = bundles * layers
  switch (type) {
    case 'Slate':
      if (cumulativeBundles <= 60) return '10 Yard Dumpster'
      return 'Multiple 10 Yard Dumpsters'
    case 'Three-Tab Asphalt':
      if (cumulativeBundles <= 70) return '10 Yard Dumpster'
      if (cumulativeBundles > 70 && cumulativeBundles <= 100) return '15 Yard Dumpster'
      if (cumulativeBundles > 100 && cumulativeBundles <= 150) return '20 Yard Dumpster'
      return 'Multiple 20 Yard Dumpsters'
    case 'Architectural Asphalt':
      if (cumulativeBundles <= 75) return '10 Yard Dumpster'
      if (cumulativeBundles > 75 && cumulativeBundles <= 110) return '15 Yard Dumpster'
      if (cumulativeBundles > 110 && cumulativeBundles <= 165) return '20 Yard Dumpster'
      return 'Multiple 20 Yard Dumpsters'
  }
}

export function getRecommendedDumpsterTitleByTons (tons) {
  if (tons <= 10) return '10 Yard Dumpster'
  return 'Multiple 10 Yard Dumpsters'
}
